module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Sign-out-5de0c2e8f35d6d5231104fb23241f73b.svg";